import React, { useCallback, useEffect, useState } from 'react';
import SigninForm from './signin_form';
import * as actions from '../../actions/auth_actions';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { AuthenticationService } from '../../services';
import Keycloak from "../../helpers/keycloak";

import config from "config";

const Signin = ({ authenticated, errorMessage, location, authError, signinUserWithToken, signinUserError }) => {
  const [authenticating, setAuthenticating] = useState(false);
  const [needSecondFactor, setNeedSecondFactor] = useState(false);

  useEffect(() => {
    return () => authError(null);
  }, [location, authError]);

  const handleSSO = useCallback(() => {
    const keycloak = new Keycloak({
        url: config.AUTH_BASE_URL,
        realm: "opsense-main",
        clientId: "sso-rest-api",
    });

    keycloak
        .init({ checkLoginIframe: false })
        .then((loggedIn) => {
            if (loggedIn) {
                signinUserWithToken(keycloak.token);
            } else {
                keycloak
                    .login({
                        redirectUri: `${window.location.origin}${config.WEB_SUB_URL.replace(/\/$/, '')}/sso-response`,
                    })
                    .catch((error) => {
                        console.error(error);
                        signinUserError("Unable to process login request.", username);
                    });
            }
        })
        .catch((error) => {
            console.error(error);
            signinUserError("Unable to process login request.", username);
        });
  });

  const handleSubmit = useCallback(({ username, password, secondFactor }) => {
    authError(null);

    // this is in a delay so that authError gets done before this is called
    // TODO revisit this
    setTimeout(() => {
      setAuthenticating(true);
      // TODO go back to this? this.props.signinUser({ username, password });

      AuthenticationService.authenticate(username, password, secondFactor).then((response) => {
        if (response.data) {
          if (response.data.requiresSecondFactor) {
            setNeedSecondFactor(true);
          } else if (response.data.token) {
            signinUserWithToken(response.data.token);
          } else {
            signinUserError('Unable to process login request.', username);
          }
        } else {
          signinUserError('Unable to process login request.', username);
        }          
      }).catch(err => {
        signinUserError(err, username);
      }).finally((_) => {
        setAuthenticating(false);
      });
    }, 100);
  }, [location, authError]);

  if (authenticated) {
    return <Redirect to={{ pathname: location?.state?.from?.pathname ?? '/', state: { from: location } }} />;
  } else {
    return (
      <div>
        { authenticating ? 
            <div style={{width: "100%", height: "100%", position: "fixed", zIndex: 10, top: 0, left: 0}}>
              <div style={{backgroundColor: "#fff", width:200, height: 200, position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)"}}>
                <div className="loader">Authenticating</div> 
              </div> 
            </div> : null 
        }
        <SigninForm onSubmit={ handleSubmit } handleSSO={handleSSO} errorMessage={ errorMessage } needSecondFactor={ needSecondFactor } />
      </div>
    );
  }
}

export default connect(({ auth }) => ({ authenticated: auth.authenticated, errorMessage: auth.error }), actions)(Signin);
